export const ID_HOST = "Host";
export const ID_CLIENT = "Client";
export const ID_TENANT = "Tenant";

export const IdentityRoleList: string[] = [ID_CLIENT, ID_HOST, ID_TENANT];
